// client/src/utils/imageResize.js
// Redimensiona um File de imagem pra um quadrado exato via canvas — usado
// pela geração de imagem por IA na Galeria, onde o upload manual exige uma
// das dimensões fixas em allowedSizes (ver GaleriaManagementPage.js). A
// resolução real devolvida pelo modelo de imagem (Venice) não bate com
// nenhuma dessas dimensões, então a imagem gerada precisa ser reamostrada
// antes de entrar no mesmo fluxo de upload do arquivo escolhido manualmente.
export const resizeImageFileToSquare = (file, targetSize) => new Promise((resolve, reject) => {
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);
    img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = targetSize;
        canvas.height = targetSize;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, targetSize, targetSize);
        canvas.toBlob((blob) => {
            URL.revokeObjectURL(objectUrl);
            if (!blob) {
                reject(new Error('Falha ao redimensionar a imagem gerada.'));
                return;
            }
            resolve(new File([blob], file.name, { type: file.type }));
        }, file.type || 'image/png');
    };
    img.onerror = () => {
        URL.revokeObjectURL(objectUrl);
        reject(new Error('Falha ao carregar a imagem gerada para redimensionamento.'));
    };
    img.src = objectUrl;
});

// Redimensiona ("cover", igual background-size:cover) um File de imagem pra
// caber exatamente em targetWidth x targetHeight, cortando o excesso do
// centro em vez de esticar/distorcer — usado pela geração de banner por IA:
// a Venice não aceita proporções fora de um preset fixo (ver
// aiImagePromptUtils.js::VENICE_ASPECT_PRESETS no server), então tipos bem
// panorâmicos (ex.: banner 'horizontal' = 46:9) sempre voltam num preset
// mais "quadrado" que o esperado — sem esse crop, a imagem reprovava a
// validação de largura mínima/proporção do banner (confirmado ao vivo).
export const resizeImageToCover = (file, targetWidth, targetHeight) => new Promise((resolve, reject) => {
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);
    img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        const ctx = canvas.getContext('2d');
        const scale = Math.max(targetWidth / img.width, targetHeight / img.height);
        const drawWidth = img.width * scale;
        const drawHeight = img.height * scale;
        const offsetX = (targetWidth - drawWidth) / 2;
        const offsetY = (targetHeight - drawHeight) / 2;
        ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
        canvas.toBlob((blob) => {
            URL.revokeObjectURL(objectUrl);
            if (!blob) {
                reject(new Error('Falha ao ajustar a imagem gerada ao tamanho do banner.'));
                return;
            }
            resolve(new File([blob], file.name, { type: file.type }));
        }, file.type || 'image/png');
    };
    img.onerror = () => {
        URL.revokeObjectURL(objectUrl);
        reject(new Error('Falha ao carregar a imagem gerada para ajustar ao tamanho do banner.'));
    };
    img.src = objectUrl;
});
